<mat-card class="content-card">
  <mat-card-header>
    <mat-card-title>
      <h5>Gift Card Brands</h5>
    </mat-card-title>
  </mat-card-header>
  <mat-card-content>
    <ng-container *ngIf="brands">
      <mat-table [dataSource]="brands">
        <ng-container matColumnDef="logo">
          <mat-header-cell *matHeaderCellDef>Logo</mat-header-cell>
          <mat-cell style="width: 60px;" *matCellDef="let brand">

            <img [src]="brand.logoUrl" [alt]="brand.name" width="50" />


          </mat-cell>
        </ng-container>
        <ng-container matColumnDef="name">
          <mat-header-cell *matHeaderCellDef>Name</mat-header-cell>
          <mat-cell *matCellDef="let brand"> {{ brand.name }}  </mat-cell>
        </ng-container>
        <ng-container matColumnDef="currency">
          <mat-header-cell *matHeaderCellDef>currency</mat-header-cell>
          <mat-cell *matCellDef="let brand"> {{ brand.currency }}  </mat-cell>
        </ng-container>
        <ng-container matColumnDef="countriesServed">
          <mat-header-cell *matHeaderCellDef style="width: 200px;">Countries</mat-header-cell>
          <mat-cell *matCellDef="let brand" style="width: 200px;"> {{ brand.countriesServed }}  </mat-cell>
        </ng-container>
        <ng-container matColumnDef="discount">
          <mat-header-cell *matHeaderCellDef style="width: 40px;">Discount</mat-header-cell>
          <mat-cell *matCellDef="let brand" style="width: 40px;"> {{ brand.discount }}  </mat-cell>
        </ng-container>
        <ng-container matColumnDef="userDiscount">
          <mat-header-cell *matHeaderCellDef style="width: 40px;">User discount</mat-header-cell>
          <mat-cell *matCellDef="let brand" style="width: 40px;"> {{ brand.userDiscount }}  </mat-cell>
        </ng-container>
        <ng-container matColumnDef="sortOrder">
          <mat-header-cell *matHeaderCellDef>Sort order</mat-header-cell>
          <mat-cell *matCellDef="let brand"> {{ brand.sortOrder }}  </mat-cell>
        </ng-container>
        <ng-container matColumnDef="userIsEnabled">
          <mat-header-cell *matHeaderCellDef>Enabled in App</mat-header-cell>
          <mat-cell *matCellDef="let brand"> {{ brand.userIsEnabled ? 'YES':'NO' }}  </mat-cell>
        </ng-container>
        <ng-container matColumnDef="category">
          <mat-header-cell *matHeaderCellDef>Category</mat-header-cell>
          <mat-cell *matCellDef="let brand"> {{ brand.category?.nameEn  }}  </mat-cell>
        </ng-container>
        <ng-container matColumnDef="link">
          <mat-header-cell *matHeaderCellDef></mat-header-cell>
          <mat-cell *matCellDef="let brand"> <a [routerLink]="brand.id.toString()"><mat-icon>visibility</mat-icon></a>  </mat-cell>
        </ng-container>

        <!-- Header and Row Declarations -->
        <mat-header-row *matHeaderRowDef="['logo', 'name', 'currency', 'countriesServed', 'discount', 'userDiscount', 'userIsEnabled', 'category', 'sortOrder', 'link']"></mat-header-row>
        <mat-row *matRowDef="let row; columns: ['logo', 'name', 'currency', 'countriesServed', 'discount', 'userDiscount', 'userIsEnabled', 'category', 'sortOrder', 'link']"></mat-row>
      </mat-table>

    </ng-container>
  </mat-card-content>
</mat-card>
